import type { TaxConfiguration } from "@shared/types";
import { AxiosRequestConfig } from "axios";
import { axios } from ".";

// Tax configuration endpoint (userApi `getTaxConfiguration`). Returns one config
// row per ship-to country for the vendor's region (VAT% + coffee-tax/KS rate).
// Passing `shippingCountryCode` narrows to a single row; omitting it returns all
// rows for the region. Response body is `{ data: TaxConfiguration[] }`.
const TAX_CONFIG_URL = "/api/v1/services/bc-services/config/tax-configuration";

export const getTaxConfigurations = async (vendorRegion: string, shippingCountryCode?: string | null): Promise<TaxConfiguration[]> => {
  const config: AxiosRequestConfig = {
    params: { vendorRegion, ...(shippingCountryCode && { shippingCountryCode }) },
  };
  const response = await axios.get<{ data: TaxConfiguration[] }>(TAX_CONFIG_URL, config);
  return response.data.data;
};
